export default function ResizeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2412_9613)">
        <path
          d="M15.3458 5.37866L4.87868 15.8458"
          stroke="currentColor"
          strokeLinecap="round"
        />
        <path
          d="M16 9.95801L9.45804 16.5"
          stroke="currentColor"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2412_9613">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
